import { z } from 'zod'

export const AdminS3Bucket = z.object({
  id: z.number().int(),
  name: z.string(),
  region: z.string(),
  status: z.string(),
  public: z.boolean(),
  storage_bytes: z.number(),
  object_count: z.number(),
  account_id: z.number().int(),
  created: z.string()
})
export type AdminS3Bucket = z.infer<typeof AdminS3Bucket>
